import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKayakingNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.48 10.08V8.87l-1 .53v.68a.5.5 0 101 0z" />
        <path d="M5.52 10.44c.035.713.226 1.41.56 2.04l1.35 2.54h1.14l1.35-2.54a4.97 4.97 0 00.58-2.33V7.79l-1 .54v1.82a4 4 0 01-.46 1.86L8 13.96l-1.04-1.95a4 4 0 01-.46-1.86v-.23z" />
        <path d="M.5 12.88l2.63-1.39c.238-.133.443-.318.6-.54l.5-.94.01-.01 4.24-2.25v-.01l3.45-1.83.06.03c.032.02.063.044.09.07.267.243.61.384.97.4.2 0 .399-.044.58-.13l1.89-1.01V2.08l-2.63 1.4a1.7 1.7 0 00-.59.54l-.42.79h-.01v.01l-1.39.73a4.788 4.788 0 00-.57-2.02L8.5 1H7.49L6.08 3.51a5.034 5.034 0 00-.58 2.34V8.2L3.99 9a.176.176 0 01-.05-.04 1.378 1.378 0 00-1.55-.27L.5 9.7zm12.64-8.32a.833.833 0 01.22-.2l1.16-.61v.92l-1.34.71c-.14.07-.21.05-.42-.11zM6.5 5.85a4 4 0 01.46-1.86L8 2.15l1.03 1.86c.31.575.471 1.217.47 1.87v.19l-1.02.55v-.7a.5.5 0 10-1 0v1.23l-.98.52zm-5 4.45l1.34-.72c.14-.06.21-.04.42.12l-.38.71a.574.574 0 01-.22.19l-1.16.62z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsKayakingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKayakingNormalXsmall;
